"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnsafeDynamicTranslate = exports.useCurrentLocale = exports.useFormatters = exports.useTranslator = void 0;
const utilities_js_1 = require("./utilities.js");
const store_js_1 = require("./store.js");
const selectors = {
    getTranslator: (state) => state.translator,
    getFormatters: (state) => state.formatters,
    getCurrentLocale: (state) => state.locale,
};
const useTranslator = () => (0, store_js_1.useStore)(selectors.getTranslator);
exports.useTranslator = useTranslator;
const useFormatters = () => (0, store_js_1.useStore)(selectors.getFormatters);
exports.useFormatters = useFormatters;
const useCurrentLocale = () => (0, store_js_1.useStore)(selectors.getCurrentLocale);
exports.useCurrentLocale = useCurrentLocale;
const useUnsafeDynamicTranslate = () => {
    (0, exports.useCurrentLocale)();
    return (...arguments_) => (0, utilities_js_1.unsafe_dynamicTranslate)(...arguments_);
};
exports.useUnsafeDynamicTranslate = useUnsafeDynamicTranslate;
//# sourceMappingURL=hooks.js.map